import React from 'react';
import { Bell } from 'lucide-react';

export default function NotificationCard({ notifications }) {
  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-6 pb-3">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <Bell className="w-5 h-5 text-[#c9a227]" />
            Notifikasi Terbaru
          </h3>
          <button className="text-sm text-gray-500 hover:text-gray-700">Lihat Semua</button>
        </div>
      </div>
      <div className="p-6 pt-0">
        {notifications.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <Bell className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>Tidak ada notifikasi baru</p>
          </div>
        ) : (
          <div className="space-y-3">
            {notifications.map(notif => (
              <div
                key={notif.id}
                className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div
                  className={`w-2 h-2 mt-2 rounded-full ${
                    notif.priority === 'high'
                      ? 'bg-red-500'
                      : notif.priority === 'medium'
                        ? 'bg-yellow-500'
                        : 'bg-blue-500'
                  }`}
                />
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm">{notif.title}</p>
                  <p className="text-xs text-gray-500 truncate">{notif.message}</p>
                </div>
                <span className="px-2 py-0.5 border border-gray-300 text-gray-700 text-xs rounded-full">
                  {notif.module}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
